module.exports = __webpack_public_path__ + "img/warning.dab3ddba.png";